// 存放订单收款信息表格内容
import { operateMaxShowLength } from '@/store/dict/config'

export default {
  data() {
    const m_receiptColumns = [
      {
        name: 'selection',
        columnProps: {
          type: 'selection',
          fixed: 'left',
          width: 80,
          selectable: (row) => {
            if (
            // 剩余应收金额为0
              Number(row.remainAmount) === 0 ||
                      row.receivableState === '已完成' ||
                      row.receivableState === '已关闭'
            ) {
              return false
            }
            return true
          },
        },
      },
      {
        name: 'id',
        columnProps: {
          label: '应收ID',
          prop: 'id',
          width: 100,
        },
      },
      {
        name: 'content',
        columnProps: {
          label: '收款内容',
          prop: 'content',
          width: 80,
        },
      },
      {
        name: 'receivableDate',
        columnProps: {
          label: '应收日期',
          prop: 'receivableDate',
          width: 100,
        },
      },
      {
        name: 'receivableAmount',
        columnProps: {
          label: '应收金额(元)',
          prop: 'receivableAmount',
          width: 110,
        },
        getText: ({ row }) => this.numberWithCommas(row.receivableAmount),
      },
      {
        name: 'receivingAmount',
        columnProps: {
          label: '收款中金额(元)',
          prop: 'receivingAmount',
          width: 160,
        },
        getText: ({ row }) => this.numberWithCommas(row.receivingAmount),
      },
      {
        name: 'receivedAmount',
        columnProps: {
          label: '已收金额(元)',
          prop: 'receivedAmount',
          width: 110,
        },
        getText: ({ row }) => this.numberWithCommas(row.receivedAmount),
      },
      {
        name: 'remainAmount',
        columnProps: {
          label: '剩余应收金额(元)',
          prop: 'remainAmount',
          width: 130,
        },
        getText: ({ row }) => this.numberWithCommas(row.remainAmount),
      },
      {
        name: 'remarks',
        columnProps: {
          label: '备注',
          prop: 'remarks',
          width: 150,
        },
      },
      {
        name: 'receivableState',
        columnProps: {
          label: '收款状态',
          prop: 'receivableState',
        },
      },
      {
        name: 'completeTime',
        columnProps: {
          label: '收款完成时间',
          prop: 'completeTime',
          width: 160,
        },
      },
      {
        name: 'changeState',
        columnProps: {
          label: '是否变更',
          prop: 'changeState',
        },
      },
      {
        name: 'operate',
        columnProps: {
          label: '操作',
          fixed: 'right',
        },
        maxShowLength: operateMaxShowLength,
        type: 'operate',
        getOperateList: ({ row }) => {
          const result = []
          // 线下收款
          const offlineReceipt = {
            name: 'offlineReceipt',
            label: '线下收款',
            action: () => this.offlineReceipt(row),
          }
          // 状态为未完成，剩余应收金额不为0展示线下首款按钮
          if (row.receivableState === '未完成' && row.remainAmount > 0) {
            result.push(offlineReceipt)
          }
          return result
        },
      },

    ]
    if (this.tabType) {
      m_receiptColumns.shift()
      m_receiptColumns.pop()
    }
    return {
      m_receiptColumns,
    }
  },
}
